export default "__VITE_ASSET__DKhxoXgB__"